<template lang="pug">
    .photo-img(:style="{width:width}")
        .wrap()
            //- TODO: ここにアニメーション周りの処理をそのうち入れます
            AnimateView.photo(:style="{width:photo.width+10+'px'}",:imgData="photo" :isPlay="isPlay")
</template>
<style lang="scss" scoped>
.photo-img {
    position: relative;
    @media screen and (max-width: 979px) {
        width: 100% !important;
    }

    &.-height {
        @media screen and (max-width: 979px) {
            width: 65% !important;
            margin: 16px auto !important;
        }
    }

    > .wrap {
        width: 100%;
        overflow: hidden;
        > .photo {
            transform: translate(-5px, -5px);
            @media screen and (max-width: 979px) {
                width: 100% !important;
            }
        }
    }
}
</style>
<script>
import AnimateView from "../components/animate-img";
export default {
    components: {
        AnimateView
    },
    props: {
        photo: {
            type: Object,
            required: true
        },
        isPlay: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            flag: false
        };
    },
    computed: {
        photoUrl() {
            return require("@/assets/img/photo/after/" +
                this.photo.photo +
                ".jpg");
        },
        paintUrl() {
            return require("@/assets/img/photo/before/" +
                this.photo.paint +
                "png");
        },
        width() {
            return this.photo.width + "px";
        },
        heightRate() {
            return this.photo.width / this.photo.height;
        }
    }
};
</script>
